/* would have used mousetrap but didn't find simple support for binding to an iframe
Combokeys is a Mousetrap fork
but look at all this bullshit gymnastics i have to do to support the iframe.
and the doucment chooser. that documnt chooser is extending it's tentacles everywhere.
i'm sure tehre's a way to refactor this to ELEGANTLY support the iframe
and a way to refactor the document chooser so that the shit that needs to be run on "init"
also gets re-run on re-init.

at least the mess is in here, and not where i use it
the only thing you have to know to use it is that initializeOrReinitializeCombokeys
needs to be fired whenever the iframe canvas gets destroyed */

import Combokeys from "combokeys";
import { isEqual } from "lodash";
import { KEYBOARD_SHORTCUTS } from "@/lib/keyboard-shortcuts/global-shortcuts";

// Same as original: https://github.com/avocode/combokeys/blob/master/Combokeys/prototype/stopCallback.js#L19
// Except it overrides the "save" event
Combokeys.prototype.stopCallback = function (
  e: KeyboardEvent,
  element: HTMLElement
) {
  // if the element has the class "combokeys" then no need to stop
  if ((" " + element.className + " ").indexOf(" combokeys ") > -1) {
    return false;
  }

  // let Combokeys handle the logic and check if this is the shortcut for saving
  if (e.code === "KeyS") {
    return false;
  }

  const tagName = element.tagName.toLowerCase();

  // stop for input, select, and textarea
  return (
    tagName === "input" ||
    tagName === "select" ||
    tagName === "textarea" ||
    element.isContentEditable
  );
};

type KeyboardShortcut = {
  keys: string | string[];
  callback: (event: KeyboardEvent) => void;
  action?: string | undefined;
};

export const keyboardShortcuts = {
  shortcuts: [] as KeyboardShortcut[],
  register(
    keys: string | string[],
    callback: (event: KeyboardEvent) => void,
    action?: string | undefined
  ) {
    this.shortcuts.push({ keys, callback, action });
    rebindShortcuts();
  },
  unbind(keys: string | string[], action?: string | undefined) {
    this.shortcuts = this.shortcuts.filter(
      shortcut => !isEqual(shortcut.keys, keys)
    );

    combokeys?.unbind(keys, action);
    iframeCombokeys?.unbind(keys, action);
  }
};

function rebindShortcuts() {
  keyboardShortcuts.shortcuts.forEach(shortcut => {
    combokeys?.unbind(shortcut.keys, shortcut.action);
    iframeCombokeys?.unbind(shortcut.keys, shortcut.action);
    combokeys?.bind(
      shortcut.keys,
      (event: KeyboardEvent) => {
        // @ts-ignore
        shortcut.callback(event);
        return false;
      },
      shortcut.action
    );
    iframeCombokeys?.bind(
      shortcut.keys,
      (event: KeyboardEvent) => {
        // @ts-ignore
        shortcut.callback(event);
        return false;
      },
      shortcut.action
    );
  });
}

let combokeys: Combokeys.Combokeys | null = null;
let iframeCombokeys: Combokeys.Combokeys | null = null;

export function initializeOrReinitializeCombokeys(
  document: Document,
  iframeCanvasDocument: Document | null = null
) {
  combokeys?.detach();
  combokeys?.reset();

  iframeCombokeys?.detach();
  iframeCombokeys?.reset();

  combokeys = new Combokeys(document.documentElement);
  if (iframeCanvasDocument) {
    iframeCombokeys = new Combokeys(iframeCanvasDocument.documentElement);
  }
  rebindShortcuts();
}

export function triggerShortcut(shortcut: keyof typeof KEYBOARD_SHORTCUTS) {
  combokeys?.trigger(KEYBOARD_SHORTCUTS[shortcut][0]);
}
